var _rect, _rect2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    width: 130,
    height: 60
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 60,
    fill: "#DC4437",
    width: 130,
    height: 60
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2A66B7",
    points: "0,0 57,60 0,120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/cz.88485f2a0d549da4fe8dc66cec981a22.svg";
export { ForwardRef as ReactComponent };